import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils/api'

import { getPackagesSettingsQueryKey } from './get-packages-settings'

type RegeneratePackageRoomUrlRequest = {
  buildingId: number
  packageRoomId?: number
}

const regeneratePackageRoomUrl = async (data: RegeneratePackageRoomUrlRequest) => {
  await authAPI.post('/package-room/generate-link', data)
}

export const useRegeneratePackageRoomUrl = (buildingId: number) => {
  return useMutation({
    mutationFn: regeneratePackageRoomUrl,
    onSuccess: () => {
      resetQueries(getPackagesSettingsQueryKey({ buildingId }))
    },
  })
}
